// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--XEb4Z","icon-img":"da51a739f7--icon-img--kXIoj","bank-img":"da51a739f7--bank-img--u_MTo"};